module.exports = __webpack_public_path__ + "static/media/web-based1.8ef21294.png";